import { gql } from "@apollo/client";

export const AddEmailConfig = gql`
  mutation AddEmailConfig(
    $token: String!
    $customerId: ID!
    $user_details: SubscribedUser!
    $input: CreateEmailConfig!
  ) {
    AddEmailConfig(
      token: $token
      customerId: $customerId
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteEmailConfig = gql`
  mutation DeleteEmailConfig(
    $token: String!
    $emailConfigId: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteEmailConfig(
      token: $token
      emailConfigId: $emailConfigId
      user_details: $user_details
    )
  }
`;

export const UpdateEmailConfig = gql`
  mutation UpdateEmailConfig(
    $token: String!
    $emailConfigId: ID!
    $user_details: SubscribedUser!
    $input: UpdateEmailConfig!
  ) {
    UpdateEmailConfig(
      token: $token
      emailConfigId: $emailConfigId
      user_details: $user_details
      input: $input
    )
  }
`;
